import { Injectable } from '@angular/core';
import { GenericService } from '../generic.service';
import { apiResponse } from '../../models/apiResponse';
import { GetScholarshipRequest, ScholarshipType } from '../../models/scholarships/getScholarshipRequest';
//import { GetScholarshipRequest } from '../../models/scholarships/getScholarshipRequest';
import { ScholarshipResponse } from '../../models/scholarships/scholarshipResponse';
import { Observable } from 'rxjs';
import { AddScholarshipRequest, UpdateScholarshipRequest } from '../../models/scholarships/addScholarshipRequest';
import { MyScholarshipResponse } from '../../models/scholarships/myScholarshipResponse';

@Injectable({
  providedIn: 'root'
})
export class ScholarshipsService {

  constructor(private genericService: GenericService) { }

  getScholarships(req: GetScholarshipRequest): Observable<apiResponse<ScholarshipResponse[]>> {
    return this.genericService.post(`scholarships/search`, req)
  }
  addScholarship(req: AddScholarshipRequest): Observable<ScholarshipResponse> {
    return this.genericService.post(`scholarships`, req)
  }
  updateScholarship(req: UpdateScholarshipRequest): Observable<ScholarshipResponse> {
    return this.genericService.put(`scholarships`, req)
  }
  deleteScholarShipRequest(scholarshipId: number): Observable<ScholarshipResponse> {
    return this.genericService.delete(`scholarships/${scholarshipId}`);
  }

  getStreamOrLevel(): Observable<apiResponse<string[]>> {
    return this.genericService.get(`scholarships/Stream-or-level`);
  }

  // getStream(): Observable<apiResponse<string[]>> {
  //   return this.genericService.get(`scholarships/Stream`);
  // }

  // getLevel(): Observable<apiResponse<string[]>> {
  //   return this.genericService.get(`scholarships/Level`);
  // }

  getStream(type?: ScholarshipType): Observable<apiResponse<string[]>> {
  return this.genericService.get(`scholarships/Stream${type != null ? `?type=${type}` : ''}`);
}

getLevel(type?: ScholarshipType): Observable<apiResponse<string[]>> {
  return this.genericService.get(`scholarships/Level${type != null ? `?type=${type}` : ''}`);
}

  getCountry(): Observable<apiResponse<string[]>> {
    return this.genericService.get(`scholarships/country`);
  }

  getDeadline(): Observable<apiResponse<string[]>> {
    return this.genericService.get(`scholarships/deadline`);
  }

  // listScholarShipsName_ByInitials(text: string): Observable<apiResponse<string[]>> {
  //   return this.genericService.get(`scholarship/search/${text}`);
  // }

  listScholarShipsName_ByInitials(text: string, type?: ScholarshipType): Observable<apiResponse<string[]>> {
  return this.genericService.get(`scholarship/search/${encodeURIComponent(text)}${type != null ? `?type=${type}` : ''}`);
}

  //My Scholarships API's
  getMyScholarships(studentId?: string): Observable<apiResponse<MyScholarshipResponse[]>> {
    return this.genericService.get(`scholarships/my-scholarships${studentId ? `?studentId=${studentId}` : ''}`);
  }
  addMyScholarship(scholarshipId: number): Observable<MyScholarshipResponse> {
    return this.genericService.post(`scholarships/my-scholarships/${scholarshipId}`, {})
  }
  deleteMyScholarShip(scholarshipId: number): Observable<MyScholarshipResponse> {
    return this.genericService.delete(`scholarships/my-scholarships/${scholarshipId}`);
  }
  getScholarshipById(id: number): Observable<ScholarshipResponse> {
    return this.genericService.get(`scholarships/${id}`);
  }

}
